export const refs = {
  allCardsSection: document.querySelector('.main-section__allcards'),
  headerFormInput: document.querySelector('form.header__form'),
  modal: document.querySelector('.modal'),
  overflow: document.querySelector('.overflow'),
  closeBtn: document.querySelector('.modal__close-btn'),
  innerModal: document.querySelector('.modal__main'),
  watchedBtn: document.querySelector('.watchedJS'),
  queueBtn: document.querySelector('.queueJS'),
  paginationContainer: document.querySelector('.tui-pagination'),
  spinner: document.querySelector('.sk-chase'),
  trailerOverflow: document.querySelector('#trailerOverflow'),
  trailerModal: document.querySelector('#trailerModal'),
  trailerDiv: document.querySelector('#trailerDiv'),
  trailerCloseBtn: document.querySelector('#trailerClose'),
  noResultsText: document.querySelector('.header__form-warning-text'),
  cursor: document.querySelector('.cursor'),
  cursorinner: document.querySelector('.cursor2'),
  body: document.querySelector('body'),
};
